module.exports = {
      id: "rte:unordered-list-usage",
      viewBox: "0 0 512 512",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#rte:unordered-list-usage",
      toString: function () {
        return this.url;
      }
    }